module.exports = __webpack_public_path__ + "img/GQ.4d7c9b81.svg";